<template>
  <el-select
    v-bind="$attrs"
    clearable
    filterable
    placeholder="请选择"
    @change="handleChange"
  >
    <el-option
      v-for="(item, index) in (dicList[props.type] || [])"
      :key="index"
      :label="item.label"
      :value="item.value"
    />
  </el-select>
</template>

<script setup name="base-select">
  import { computed } from 'vue';
  import { useAppStore } from '@/store/app';

  const props = defineProps({
    type: {
      required: true,
      type: String,
      default: '',
    },
  });

  const emit = defineEmits(['update:modelValue']);

  const appStore = useAppStore();
  const dicList = computed(() => appStore.dicList);

  const handleChange = (val) => {
    emit('update:modelValue', val);
  };
</script>
